import { getImage, getSrc } from "gatsby-plugin-image"

export const getMetaImageSrc = entry => {
  // getImage and getSrc work safely when there is no image
  // https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/#helper-functions
  const image = getImage(entry.metaImage) ?? getImage(entry.image)
  return getSrc(image)
}

export const isClient = () => typeof window !== "undefined"

export const getDescription = page =>
  page.metaDescription ? page.metaDescription.metaDescription : null

export const getTitle = page => page.metaTitle ?? page.title
